var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationNoApprove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1152 1152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6eeff;}.cls-2{fill:#9ce8ff;}.cls-3{fill:#abefff;}.cls-12,.cls-13,.cls-15,.cls-4,.cls-6,.cls-7,.cls-9{fill:none;}.cls-4{stroke:#c0fcff;}.cls-4,.cls-6{stroke-miterlimit:10;stroke-width:42px;}.cls-5{fill:#e1e9f4;}.cls-6{stroke:#8cd0e0;}.cls-7{stroke:#3784c4;}.cls-12,.cls-13,.cls-15,.cls-7,.cls-8,.cls-9{stroke-linecap:round;}.cls-11,.cls-12,.cls-13,.cls-15,.cls-7,.cls-8,.cls-9{stroke-linejoin:round;}.cls-11,.cls-7,.cls-8,.cls-9{stroke-width:43px;}.cls-10,.cls-8{fill:#8277b7;}.cls-8{stroke:#8277b7;}.cls-11,.cls-9{stroke:#8b83c6;}.cls-11{fill:#8b83c6;}.cls-12{stroke:#cfcfff;stroke-width:8px;}.cls-13{stroke:#70679e;stroke-width:27px;}.cls-14{fill:#d4feff;}.cls-15{stroke:#fff;stroke-width:45px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_20_copia",
    "data-name": "Capa 20 copia"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_5_copia_2",
    "data-name": "Capa 5 copia 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 576,
    cy: 576,
    r: 576
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 244.5,
    y: 212.5,
    width: 661,
    height: 776
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M904.5,372.7q-274.83,366.84-662,541L294,990H849l56-52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M843.35,249.46c-5.11,0-540.71.2-544.78.75-14.29,2-22.07,8.35-22.07,26.25v647c0,24,9.2,42.56,41.85,40,10-.78,525.32-4.65,532-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1152,576c0,318.12-257.88,576-576,576a573.3,573.3,0,0,1-310.46-90.75C693,1201.67,1044.77,997,1152,576Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M807.5,218.5c27.21-2.58,60,10,67,61.22V904.5c2.45,31.16-.23,51.43-31,55-3,.35-426.43-8.14-539-.77-48,.77-63.06-40.29-57-73.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 242.5,
    y: 214.5,
    width: 662,
    height: 775,
    rx: 51.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 406,
    y: 160,
    width: 335,
    height: 122
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 574,
    cy: 138,
    r: 62.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 574,
    cy: 133,
    r: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M406,281V160H741C649.71,173.59,477.16,236.2,406,281Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M516.75,105.33a62.55,62.55,0,0,1,46.51-31.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "406 220.5 406 160 496.5 160"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "749.5 151 749.5 289.55 402 289.55"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 684,
    cy: 771,
    r: 150.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 360.5,
    y1: 442.5,
    x2: 787.5,
    y2: 442.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 361,
    y1: 589,
    x2: 788,
    y2: 589
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 361,
    y1: 755,
    x2: 450,
    y2: 755
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 570.08,
    y1: 796.93,
    x2: 634.91,
    y2: 860.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 784.02,
    y1: 711.73,
    x2: 634.91,
    y2: 860.84
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationNoApprove);
export default __webpack_public_path__ + "static/media/Illustration_noApprove.500235880d46953cad502222ac9e932a.svg";
export { ForwardRef as ReactComponent };